export default "__VITE_ASSET__b08d28fa__"